"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createConnect_1 = require("./createConnect");
exports.default = createConnect_1.default({
    field: 'config'
});
//# sourceMappingURL=connectConfig.js.map